import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f4a87bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "listItem" }
const _hoisted_2 = { class: "listItemHeader" }
const _hoisted_3 = { class: "vendorName" }
const _hoisted_4 = { class: "toggleContainer" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"1"} }, null, -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "listItemDetail"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vendorPurposeOrFeatureLabel" }, "Purposes that Require Consent", -1))
const _hoisted_10 = { class: "vendorPurposeOrFeatureID" }
const _hoisted_11 = {
  key: 1,
  class: "listItemDetail"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vendorPurposeOrFeatureLabel" }, "Special Purposes", -1))
const _hoisted_13 = { class: "vendorPurposeOrFeatureID" }
const _hoisted_14 = {
  key: 2,
  class: "listItemDetail"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vendorPurposeOrFeatureLabel" }, "Features", -1))
const _hoisted_16 = { class: "vendorPurposeOrFeatureID" }
const _hoisted_17 = {
  key: 3,
  class: "listItemDetail"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vendorPurposeOrFeatureLabel" }, "Special Features", -1))
const _hoisted_19 = { class: "vendorPurposeOrFeatureID" }
const _hoisted_20 = {
  key: 4,
  class: "listItemDetail"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vendorPurposeOrFeatureLabel" }, "Partner's Privacy Policy", -1))
const _hoisted_22 = { class: "vendorPurposeOrFeatureDesc" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vendorPurposeOrFeatureID" }, " ", -1))
const _hoisted_24 = ["href"]
const _hoisted_25 = {
  key: 5,
  class: "vendorPurposeOrFeatureDesc"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vendorPurposeOrFeatureID" }, "--", -1))
const _hoisted_27 = {
  key: 6,
  class: "vendorPurposeOrFeatureDesc"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vendorPurposeOrFeatureID" }, "--", -1))
const _hoisted_29 = {
  key: 7,
  class: "vendorPurposeOrFeatureDesc"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vendorPurposeOrFeatureID" }, "--", -1))
const _hoisted_31 = {
  key: 8,
  class: "vendorPurposeOrFeatureDesc"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vendorPurposeOrFeatureID" }, "--", -1))
const _hoisted_33 = {
  key: 9,
  class: "vendorPurposeOrFeatureDesc"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vendorPurposeOrFeatureID" }, "--", -1))
const _hoisted_35 = { key: 10 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vendorPurposeOrFeatureLabel" }, "Device Storage Disclosure:", -1))
const _hoisted_37 = { class: "vendorPurposeOrFeatureDesc" }
const _hoisted_38 = {
  key: 1,
  style: {"font-weight":"500"}
}
const _hoisted_39 = { style: {"margin":"12px 0 1px 12px"} }
const _hoisted_40 = { class: "vendorPurposeOrFeatureID" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggle_button = _resolveComponent("toggle-button")!
  const _component_ChevronIcon = _resolveComponent("ChevronIcon")!
  const _component_Vue3SlideUpDown = _resolveComponent("Vue3SlideUpDown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.vendor.name), 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        (this.mergedPurposes && this.mergedPurposes.length)
          ? (_openBlock(), _createBlock(_component_toggle_button, {
              key: 0,
              onChange: _ctx.changeConsent,
              sync: true,
              value: _ctx.consent,
              style: {"margin-left":"8px"},
              width: 64,
              height: 30,
              speed: 200,
              color: {checked: '#34b76f', unchecked: '#94a7d1'}
            }, null, 8, ["onChange", "value"]))
          : _createCommentVNode("", true),
        _createVNode(_component_ChevronIcon, {
          onClick: _ctx.expandCollapseClick,
          class: _normalizeClass(_ctx.collapseClass)
        }, null, 8, ["onClick", "class"])
      ])
    ]),
    (_ctx.expanded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_Vue3SlideUpDown, {
            modelValue: _ctx.expanded,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.expanded) = $event)),
            duration: 200,
            class: "listItemDetail"
          }, {
            default: _withCtx(() => [
              (this.mergedPurposes && this.mergedPurposes.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.mergedPurposes, (id) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "vendorPurposeOrFeatureDesc",
                        key: id
                      }, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(id), 1),
                        _createTextVNode(_toDisplayString(_ctx.purposes[id] ? _ctx.purposes[id].name : "[ MISSING IN VENDOR LIST]"), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (this.vendor.specialPurposes && this.vendor.specialPurposes.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _hoisted_12,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.vendor.specialPurposes, (id) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "vendorPurposeOrFeatureDesc",
                        key: id
                      }, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(id), 1),
                        _createTextVNode(_toDisplayString(_ctx.specialPurposes[id] ? _ctx.specialPurposes[id].name : "[ MISSING IN VENDOR LIST]"), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (this.vendor.features && this.vendor.features.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _hoisted_15,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.vendor.features, (id) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "vendorPurposeOrFeatureDesc",
                        key: id
                      }, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(id), 1),
                        _createTextVNode(_toDisplayString(_ctx.features[id] ? _ctx.features[id].name : "[ MISSING IN VENDOR LIST]"), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (this.vendor.specialFeatures && this.vendor.specialFeatures.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _hoisted_18,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.vendor.specialFeatures, (id) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "vendorPurposeOrFeatureDesc",
                        key: id
                      }, [
                        _createElementVNode("div", _hoisted_19, _toDisplayString(id), 1),
                        _createTextVNode(_toDisplayString(_ctx.specialFeatures[id] ? _ctx.specialFeatures[id].name : "[ MISSING IN VENDOR LIST]"), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (this.vendor.policyUrl && this.vendor.policyUrl.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("a", {
                        style: {"font-weight":"600"},
                        target: "_blank",
                        href: this.vendor.policyUrl
                      }, _toDisplayString(this.vendor.policyUrl), 9, _hoisted_24)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (this.vendor.usesCookies && this.vendor.cookieRefresh)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _hoisted_26,
                    _createTextVNode("This partner uses cookies and may refresh them when you access the site.")
                  ]))
                : _createCommentVNode("", true),
              (this.vendor.usesCookies && (! this.vendor.cookieRefresh))
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _createTextVNode("This partner uses cookies that are not refreshed when you access the site.")
                  ]))
                : _createCommentVNode("", true),
              (! this.vendor.usesCookies)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _hoisted_30,
                    _createTextVNode("This partner does not make use of cookies.")
                  ]))
                : _createCommentVNode("", true),
              (this.vendor.usesCookies && this.vendor.cookieMaxAgeSeconds)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _hoisted_32,
                    _createTextVNode("This partner may store cookies for a maximum duration of " + _toDisplayString(this.cookieDuration) + ".", 1)
                  ]))
                : _createCommentVNode("", true),
              (this.vendor.usesNonCookieAccess)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _hoisted_34,
                    _createTextVNode("Besides cookies, this partner may use other methods of storage or accessing information already on the device (e.g., local storage, indexDB or similar).")
                  ]))
                : _createCommentVNode("", true),
              (this.vendor.deviceStorageDisclosureUrl && this.vendor.deviceStorageDisclosureUrl.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, [
                      (_ctx.disclosures.length == 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "cmpButtonLink disclosureButton",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.disclosureURLClick && _ctx.disclosureURLClick(...args)))
                          }, "Click for Details"))
                        : _createCommentVNode("", true),
                      (_ctx.disclosures.length > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_38, "This partner discloses the following data may be stored:"))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.disclosures, (d) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: d.identifier
                        }, [
                          _createElementVNode("p", _hoisted_39, _toDisplayString(d.description), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(d.purposes, (id) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "vendorPurposeOrFeatureDesc",
                              key: id
                            }, [
                              _createElementVNode("div", _hoisted_40, _toDisplayString(id), 1),
                              _createTextVNode(_toDisplayString(_ctx.purposes[id] ? _ctx.purposes[id].name : "[ MISSING IN VENDOR LIST]"), 1)
                            ]))
                          }), 128))
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ]))
}